var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceHistoryActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m15.72 13.258 6.394 6.394-2.219 2.218-6.393-6.394Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m15.72 12.197 7.454 7.455-3.279 3.279-7.454-7.455Zm5.333 7.455-5.333-5.333-1.158 1.157 5.333 5.333Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#12223e",
  d: "M10.687 11.936 6.586 7.983l1.04-1.08 4.1 3.953Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m4.411 2.28-2.52 2.446 3.607 3.632 2.693-.124V5.566Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m4.385 1.262 4.558 3.962V8.95l-3.741.172L.826 4.716Zm3.058 4.646-3-2.609-1.481 1.437L5.8 7.593l1.645-.075Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7c751",
  d: "m2.454 19.478 5.672-5.672 2.11.142.109 2.077-5.672 5.672Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7c751",
  d: "m4.672 22.757-3.279-3.279 6.443-6.443 3.114.209.161 3.075Zm-1.158-3.279 1.158 1.158 4.906-4.905-.056-1.079-1.106-.074Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7c751",
  d: "m10.132 15.111-1.06-1.06 7.416-7.416 1.06 1.06Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7c751",
  d: "m21.999 6.67-4.274-3.879-.816.973V1.726l-.816-.66L12.9 4.79l.519.6 2.293-.2-.828.986 3.121 3.113 1.153-1.186 2.594 2.149.445-.642Z"
})));
export { SvgServiceHistoryActive as ReactComponent };
export default "/_next/static/images/service_history-active.svg";